import { Deserializable } from '../deserializable';

export class SearchRequest implements Deserializable {
    id: number;
    entityType: number;
    timePeriod: number;
    fromDate: string;
    toDate: string;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
      }
}
